import { useContext } from 'react';
import { BrandContext } from '../../providers/BrandProvider';

export default function useBrand() {
  return useContext(BrandContext);
}
